
import XHeader from 'vux/src/components/x-header/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'

import { request } from "../../utils/axios";

import axios from "axios";
export default {
components: {
XHeader,
Card,
Tabbar,
TabbarItem,
Scroller,

Toast,
XButton,

Search,
Cell,
CellBox,
CellFormPreview,
},
data() {
return {
size: 10,

page: 1,
showMenus: 1, // 初始显示第一个视图
contentData: [], // 用于存储列表数据
pulldownConfig: {
content: "下拉刷新",
height: 40,
autoRefresh: false,
downContent: "下拉刷新",
upContent: "释放后刷新",
loadingContent: "正在刷新...",
clsPrefix: "xs-plugin-pulldown-",
},
show5: false,
code: null,
pullupConfig: {
content: "",
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: "释放后加载",
upContent: "",
loadingContent: "加载中...",
clsPrefix: "xs-plugin-pullup-",
},
appointmentNumber: "",
driver: "",
driverPhone: "",
carNo: "",
customer: "",
supplier: "",
reservationDocStatus: "",
};
},

mounted() {


this.fetchData();
},
methods: {
init() {
console.log(11111);
},

changeType(data) {
this.reservationDocStatus = data;
this.fetchData();
},
tabbarchange(index) {
this.showMenus = index; 
},
getQueryString(name) {
const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
const r = window.location.search.substr(1).match(reg);
if (r != null) return unescape(r[2]);
return null;
},

beforeDestroy() {

sessionStorage.removeItem("userNum");
},
beforeRouteLeave(to, from, next) {

console.log("quye");
},
toDetail(item) {
this.$router.push({
path: `/appointment-form-management/detail/${item.reservationDocId}`,



});
if (!sessionStorage.getItem("routerPush")) {
sessionStorage.setItem("routerPush", true);
}
},


fetchData() {
request(
"get",
`/hitf/v2p/rest/invoke/mt-reservation-docs?size=${
this.size
}&reservationDocNum=${this.appointmentNumber}&supplierName=${
this.supplier
}&customerName=${this.customer}&vehicleCode=${this.carNo}&driver=${
this.driver
}&driverPhone=${this.driverPhone}&reservationDocStatus=${
this.reservationDocStatus
}&contactPerson=${sessionStorage.getItem("userNum")}`
)
.then((response) => {
this.contentData = response.data.content;
this.$refs.scroller.reset(
{
left: 0,
top: 0,
},
300,
"ease"
);
})
.catch((error) => {
alert("Error fetching data:", error);
});
},


refresh() {
this.fetchData(); 
},

loadMore() {
this.size += 10;
this.pullupConfig.downContent = "---已经到底了---";
request(
"get",
`/hitf/v2p/rest/invoke/mt-reservation-docs?size=${
this.size
}&reservationDocNum=${this.appointmentNumber}&supplierName=${
this.supplier
}&customerName=${this.customer}&vehicleCode=${this.carNo}&driver=${
this.driver
}&driverPhone=${this.driverPhone}&reservationDocStatus=${
this.reservationDocStatus
}&contactPerson=${sessionStorage.getItem("userNum")}`
)
.then((response) => {
if (this.contentData.length >= response.data.totalElements) {
this.show5 = true;
}
this.contentData = response.data.content;
this.pullupConfig.content = "---已经到底了---";
this.$refs.scroller.donePullup();
})
.catch((error) => {
console.error("Error fetching data:", error);
});



console.log("没有更多数据");
},
},
};



// WEBPACK FOOTER //
// ./src/views/AppointmentFormManagement/home.vue